import { HttpClient } from "../../services/api/httpclient.service";

export interface LookupItem {
  id: number;
  name: string;
  is_active: boolean;
}

export interface StoryTypeItem {
  id: number;
  name: string;
}

export interface QuestionItem {
  id: number;
  question_text: string;
  question_type: number;
  is_active: boolean;
}

export class LookupService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient();
  }

  async getEyeColors(): Promise<LookupItem[]> {
    return await this.httpClient.get('/lookups/get_lu_characters_eye_colors');
  }

  async getHairTypes(): Promise<LookupItem[]> {
    return await this.httpClient.get('/lookups/get_lu_characters_hair_type');
  }

  async getHairColors(): Promise<LookupItem[]> {
    return await this.httpClient.get('/lookups/get_lu_characters_hair_color');
  }

  async getStoryTypes(): Promise<StoryTypeItem[]> {
    return await this.httpClient.get('/lookups/get_lu_story_type');
  }

  async getIllustrationStyles(): Promise<LookupItem[]> {
    return await this.httpClient.get('/lookups/get_lu_illustration_style');
  }

  async getStoryTones(): Promise<LookupItem[]> {
    return await this.httpClient.get('/lookups/get_lu_story_tone');
  }

  async getStorySpirits(): Promise<LookupItem[]> {
    return await this.httpClient.get('/lookups/get_lu_story_spirit');
  }

  async getActiveQuestions(): Promise<QuestionItem[]> {
    return await this.httpClient.get('/questions/get_active_questions');
  }
}

